module.exports = __webpack_public_path__ + "img/accord21.c21801cf.png";